import './SideBar.css'
import {Link, useLocation, useNavigate} from "react-router-dom";
import {useContext, useEffect, useState} from "react";
import {API_URL_PREFIX, APP_URL_PREFIX} from "../../utilities//Constants";
import CompanyTeamContext from "../../CompanyTeamContext";
import FlexBox from "../utilities/FlexBox";
import {ChevronBarLeft, ChevronBarRight, X} from "react-bootstrap-icons";
import {TEST_BUILDER_PRIVILEGE} from "../../utilities/Constants";
import axios from "axios";
import {CustomErrorToast, CustomLoadingToast, updateCustomSuccessToast} from "../utilities/CustomToast";

import ModalBackground from "../utilities/modal/ModalBackground";

import * as SVGS from '../../assets/side-bar/SVGS'
import React from "react";
import LogoImg from '../../assets/newLogo.svg'
import LogoutMobileIcon from '../../assets/dashboard/logoutMobile.svg'



const SideBar = ({active, mobileMenuOpen, onMobileMenuClose}) => {
    let {name} = useContext(CompanyTeamContext) || {}
    const [collapse, setCollapse] = useState(false)
    let collapseClass = collapse ? "collapse-bar" : "";
    const [privileges, setPrivileges] = useState([])
    const [plan, setPlan] = useState("")
    const company = useContext(CompanyTeamContext)
    const [showSupport, setShowSupport] = useState(false)
    const navigate = useNavigate()

    const logout = () => {
        const id = CustomLoadingToast("Processing")
        axios.post(API_URL_PREFIX+"/LiteLogout.html")
            .then(e => {
                let data = e.data;
                if (data && data.result == true) {
                    updateCustomSuccessToast("Logged out!", id)
                    if (company.refresh) company.refresh();
                    navigate("/users/login")
                } else {
                    CustomErrorToast("Try again.")
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    useEffect(() => {
        if (company && company.privileges) {
            setPrivileges(company.privileges || []);
        }
        if (company && `company.selectedLitePlan`) {
            setPlan(company.selectedLitePlan)
        }
    }, [company])

    const mobileClass = mobileMenuOpen ? "mobile-sidebar-open" : "";

    return (<>
        {/* Mobile Overlay */}
        {mobileMenuOpen && <div className="mobile-sidebar-overlay" onClick={onMobileMenuClose}></div>}

        <div className={"side-bar " + collapseClass + " " + mobileClass} style={{position: "relative", zIndex: 1}}>
            {/* Mobile Close Button */}
            <X className="mobile-close-btn" size={24} onClick={onMobileMenuClose} style={{cursor:"pointer"}} />

            <div style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                width: "100%"
            }}>
                <div>
            <span hidden={collapse}>
                <Logo name={name} src={LogoImg}/>
            </span>
                    <CollapseBar collapse={collapse} onClick={e => setCollapse(!collapse)}/>
                    <br/>
                    <SideBarButtons logout={logout} onMobileMenuClose={onMobileMenuClose} setShowSupport={setShowSupport} company={company} hidden={collapse} privileges={privileges} plan={plan}/>
                </div>
            </div>
            {showSupport && <SupportModal show={showSupport} setShow={setShowSupport} />}
        </div>
    </>)
}

const SupportModal = ({setShow}) => {
    return (<ModalBackground style={{position:"fixed"}}>
        <FlexBox justify={"center"} align={"center"} direction={"column"} className={"hard-shadow"} style={{position:"relative",width:"60%", maxWidth:"400px", height:"70%", maxHeight:"170px", background:"white"}}>
          <X size={"25px"} style={{position:"absolute",right:0,top:0, cursor:"pointer"}} onClick={e=>setShow(false)}/>
            <p style={{fontWeight:"bold", fontSize:"25px"}}>Need Help?</p>
            <p style={{fontSize:"18px"}}>Contact us at <a href={"mailto:info@lugo-test.com"}>info@lugo-test.com</a></p>
        </FlexBox>
    </ModalBackground>)
}

function CollapseBar(props) {
    return <div className="desktop-collapse-btn" style={{textAlign: "right", position: "absolute", top: 15, right: 5}}>
        {props.collapse ? <ChevronBarRight size={"20px"} onClick={props.onClick} style={{cursor: "pointer"}}/> :
            <ChevronBarLeft size={"20px"} onClick={props.onClick} style={{cursor: "pointer"}}/>}
    </div>;
}

function SideBarButtons(props) {

    return <>
        <Page onClick={props.onMobileMenuClose} hidden={props.hidden} style={{marginBottom: "15px"}} icon={SVGS.SVGDashboard} name={"Dashboard"}
              target={APP_URL_PREFIX + "/dashboard"}/>

        {/* Mobile: Show only essential menu items */}
        <Page onClick={props.onMobileMenuClose} className="mobile-only" disabled={!props.plan} icon={SVGS.SVGTestsStatus}
              name={"Tests Results"} target={APP_URL_PREFIX + "/quiz/list"}/>

        <Page onClick={props.onMobileMenuClose} className="mobile-only" icon={SVGS.SVGTestsList} name={"Test Library"}
              target={APP_URL_PREFIX + "/test/list"}/>

        <Page onClick={props.onMobileMenuClose} className="mobile-only" disabled={!props.plan} icon={SVGS.SVGNewCandidate}
              name={"New Candidate"} target={APP_URL_PREFIX + "/candidate/new"}/>

        <Page onClick={props.onMobileMenuClose} className="mobile-only" disabled={!props.plan} icon={SVGS.SVGCandidatesList}
              name={"Candidates List"} target={APP_URL_PREFIX + "/candidate/list"}/>

        {/* Mobile Logout Button */}
        <div className="mobile-logout-container mobile-only" style={{display: "none", marginTop: "60px"}}>
            <div style={{borderTop: "1px solid #7C7C7C", margin: "0 30px", marginBottom: "10px"}}></div>
            <div className="page mobile-only" onClick={() => {props.logout(); props.onMobileMenuClose();}} style={{cursor: "pointer"}}>
                <img src={LogoutMobileIcon} alt="Logout" style={{width: "20px", height: "20px"}} />
                <span style={{marginLeft: "20px", color: "#774CF2", fontSize: "15px", fontWeight: "600"}}>Logout</span>
            </div>
        </div>

        {/* Desktop: Show full categorized menu */}
        <Category hidden={props.hidden} name={"Test"} className="desktop-only">
            <Page onClick={props.onMobileMenuClose} disabled={!props.privileges.includes(TEST_BUILDER_PRIVILEGE)} icon={SVGS.SVGNewTest} name={"New Test"}
                  target={APP_URL_PREFIX + "/test/new"}/>

            <Page onClick={props.onMobileMenuClose} disabled={!props.privileges.includes(TEST_BUILDER_PRIVILEGE)} icon={SVGS.SVGNewLiveTest} name={"New Live Test"}
                  target={APP_URL_PREFIX + "/test/live/new"}/>

            <Page onClick={props.onMobileMenuClose} disabled={!props.plan} icon={SVGS.SVGTestsStatus}
                  name={"Tests Results"} target={APP_URL_PREFIX + "/quiz/list"}/>

            <Page onClick={props.onMobileMenuClose} icon={SVGS.SVGTestsList} name={"Test Library"}
                  target={APP_URL_PREFIX + "/test/list"}/>

            <Page onClick={props.onMobileMenuClose} disabled={!props.privileges.includes(TEST_BUILDER_PRIVILEGE)} icon={SVGS.SVGPrivateQuestions} name={"Private Questions"}
                  target={APP_URL_PREFIX + "/test/questions/builder"}/>

            <Page onClick={props.onMobileMenuClose} disabled={!props.plan} icon={SVGS.SVGTestWizard} name={"New Test Wizard"}
                  target={APP_URL_PREFIX + "/test/new/wizard"}/>
        </Category>

        <Category hidden={props.hidden} name={"Candidate"} className="desktop-only">
            <Page onClick={props.onMobileMenuClose} disabled={!props.plan} icon={SVGS.SVGNewCandidate}
                  name={"New Candidate"} target={APP_URL_PREFIX + "/candidate/new"}/>
            <Page onClick={props.onMobileMenuClose} disabled={!props.plan} icon={SVGS.SVGCandidatesList}
                  name={"Candidates List"} target={APP_URL_PREFIX + "/candidate/list"}/>
        </Category>


        <Category hidden={props.hidden || (props.company?.isBusinessLiteCompany && props?.company?.loggedLiteUser?.role != 1)} name={"Billing"} className="desktop-only">
            <Page onClick={props.onMobileMenuClose} icon={SVGS.SVGBilling} name={"Plans & Billing"} target={APP_URL_PREFIX + "/billing"}/>
            <Page onClick={props.onMobileMenuClose} icon={SVGS.SVGPricing} name={"Pricing"} target={APP_URL_PREFIX + "/pricing"}/>
            <Page onClick={props.onMobileMenuClose} icon={SVGS.SVGInvoices} name={"Invoices"} target={APP_URL_PREFIX + "/invoices"}/>
            <Page onClick={props.onMobileMenuClose} disabled={!props.plan} icon={SVGS.SVGTestsStatus}
            name={"Tests Reports"} target={APP_URL_PREFIX + "/quiz/report"}/>

        </Category>

        <Category hidden={props.hidden || !(props?.company?.loggedLiteUser) || props?.company?.loggedLiteUser?.role != 1 || !(props.company?.isBusinessLiteCompany) } name={"Company"} className="desktop-only">
            <Page onClick={props.onMobileMenuClose} icon={SVGS.SVGCandidatesList} name={"Users Management"} target={APP_URL_PREFIX + "/user/manage"}/>
        </Category>

        <Category hidden={props.hidden || (props.company?.isBusinessLiteCompany && props?.company?.loggedLiteUser?.role != 1)} name={"Preferences"} className="desktop-only">
            <Page onClick={props.onMobileMenuClose} icon={SVGS.SVGEmailSettings} name={"Mail Invitation"} target={APP_URL_PREFIX + "/preferences"}/>
            <Page onClick={props.onMobileMenuClose} icon={SVGS.SVGSettings} name={"User Agreement"} target={APP_URL_PREFIX + "/preferences/agreement"}/>
        </Category>


        <div hidden={props.hidden} className={"page desktop-only"}>
            {React.createElement(SVGS.SVGSupport, {})}
            <a href={"https://support.lugo-test.com/support/solutions"} target="_blank" rel="noopener noreferrer" className={"page-title"}>{"Support"}</a>
        </div>
    </>;
}


const Category = ({name, children, hidden, className = ""}) => {
    return (<div hidden={hidden} className={"category " + className}>
        <p style={{marginBottom: "0px"}} className={"category-title"}>{name}</p>
        {children}
    </div>)
}

const Page = ({icon, name, target, disabled, hidden, style = {}, onClick, className = ""}) => {
    const loc = useLocation()
    const [active, setActive] = useState(false);
    useEffect(() => {
        setActive(loc.pathname == target);
    }, [loc])
    if (hidden) return "";
    return (
        <div style={{...style, cursor: disabled ? "not-allowed" : ""}} title={disabled ? "Select Plan to Start." : ""}
             className={"page " + (active ? "active" : "") + " " + (disabled ? "disabled" : "") + " " + className}>
            {/*<img className={(disabled ? "disabled-img" : "") + (active ? " active-img" : "")} src={icon} alt={name}/>*/}
            {React.createElement(icon, {color:(disabled && !active ? ("#ebebeb") : (active ? "#764BF2" : "#7b7880"))})}
            {disabled ? <Link disabled={disabled} to={"#"} onClick={e => e.preventDefault()}
                              className={"page-title page-title-disabled"}>{name}</Link> :
                <Link disabled={disabled} to={target} onClick={onClick} className={"page-title"}>{name}</Link>}

        </div>)
}

const Logo = ({src, name}) => {
    return (<div style={{marginBottom: "7px",
        display: "flex",
        justifyContent: "start",
        fontSize: "20px",
        alignItems: "flex-end"}}
                 className={"page no-hover-background"}>
        <img src={src} alt={name} style={{maxWidth: "90%"}}/>Lugo-Test
    </div>)
}


export default SideBar